import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './style.scss';

import { loadingGreen } from 'redhotpie-shared-lib/themes/ImagesSVG';
import Img from 'components/common/Img';

const Loader = ({ msg, className = '' }: { msg: string; className?: string }) => {
  const customOverlayClass = cn({
    'webim-loading': !className,
    [className]: className,
  });
  return (
    <div className={customOverlayClass}>
      <Img src={loadingGreen} alt="ic-loading" />
      <span>{msg}</span>
    </div>
  );
};

export default Loader;
